<template>
    <div class="share-page-container">
        <!-- 加载状态 -->
        <div class="loading-overlay" v-if="isLoading">
            <div class="loading-content">
                <i class="el-icon-loading loading-icon"></i>
                <span class="loading-text">加载中...</span>
            </div>
        </div>

        <div v-show="!isLoading">

            <el-row :gutter="20">

                <el-col :xs="24" :sm="24" :lg="12">
                    <div class="biaoqian">用户信息</div>
                    <el-card class="box-card" style="border-radius:10px;" shadow="never">
                        <!-- <el-image style="width: 100%;" :src="require('@/assets/share.jpg')"></el-image> -->
                        <div style="margin-top: 20px;">
                            <div style="display: flex;align-items: center;">
                                <el-tag type="success" style="font-size: 13px;">
                                    已邀请{{ share_num
                                    }}人,邀请奖励余额:{{ share_yqfl }}元
                                </el-tag>

                                <el-button type="success" size="mini" :disabled="!canTixian()" :loading="lagging"
                                    style="margin-left: 5px;" @click="tixian_fc()">
                                    提现</el-button>
                                <el-tooltip class="item" effect="dark" content="满100元可提现，只能提现100的倍数,每个月最后一天到账"
                                    placement="top-start" style="margin-left: 5px;">
                                    <i class="el-icon-info"></i>
                                </el-tooltip>
                            </div>

                            <div>
                                <div style="margin: 10px 0px;font-size: 14px;">邀请二维码</div>
                                <div style="display: flex;width: 100%;margin-top: 10px;justify-content: space-between;">
                                    <div id="qrcode_share" ref="qrcode_share"></div>
                                    <!-- <div style="position:relative;">
                                        <div style="position:absolute;bottom: 0;right: 0;">
                                            <el-button type="primary" size="medium" @click="copy(share_url)"
                                                style="margin-top: 10px;">生成海报
                                            </el-button>
                                        </div>

                                    </div> -->
                                </div>
                                <div style="margin: 10px 0px;font-size: 14px;">邀请链接</div>
                                <el-input size="medium" v-model="share_url" disabled class="input-with-select">
                                    <!-- <el-button  slot="append" icon="el-icon-search" @click="copy(share_url)" style="background-color: #fff;">一键复制
                                    </el-button> -->
                                </el-input>

                                <div style="display: flex;justify-content: end;align-items: center;margin-top: 15px;">

                                    <!-- <el-checkbox v-model="share_look">对邀请的用户隐藏邀请返利</el-checkbox> -->


                                    <el-button type="primary" size="medium" @click="copy(share_url)">一键复制
                                    </el-button>


                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>

                <el-col :xs="24" :sm="24" :lg="12">
                    <div class="biaoqian">奖励记录</div>
                    <el-card class="box-card" style="border-radius:10px;" shadow="never">
                        <el-table :data="share_orderdata" stripe style="width: 100%;margin-top: 10px;" size="mini">
                            <el-table-column prop="username" label="用户" min-width="120">
                            </el-table-column>
                            <el-table-column prop="class" label="类型" width="80">
                            </el-table-column>
                            <el-table-column prop="fl_money" label="奖励金额(元)">
                            </el-table-column>
                            <el-table-column prop="time" label="日期" :formatter="formatDate">
                            </el-table-column>
                        </el-table>
                        <el-pagination small layout="prev, pager, next" :page-size="12" :total="total"
                            @current-change="fy_page" :current-page="share_page" style="margin-top: 20px;">
                        </el-pagination>
                    </el-card>
                </el-col>

            </el-row>
        </div>

        <!-- 提现对话框 -->
        <el-dialog title="提现" :visible.sync="tixian_show" custom-class="newdialog">
            <div style="display: flex;align-items: center;">
                <div style="margin-right: 20px;">提现金额:</div>
                <el-input-number v-model="tixian_money" :step="100" :max="share_yqfl" :min="100" size="small">
                </el-input-number>
                <div style="margin-left: 5px;">元</div>
            </div>
            <div style="margin-top: 30px;display: flex; align-items: center;">
                <div style="margin-right: 10px;">支付宝截图:</div>
                <el-upload class="upload-demo" action="#" ref="upload" :auto-upload="false" :limit="1"
                    :http-request="upload_sp" :before-upload="upload_fast" :file-list="videoFileList"
                    :on-exceed="upload_xianzhi" :on-change="upload_change" :on-remove="upload_remove"
                    accept=".jpg,.png">
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            </div>
            <div style="margin-top: 30px;text-align: end;">
                <el-button type="success" size="medium" @click="tixian">提现</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import QRCode from 'qrcodejs2'
export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            isLoading: true, // 加载状态
            share: false,
            share_url: '',
            share_look: false,
            share_orderdata: [],
            share_page: 1,
            share_num: 0,
            share_yqfl: 0,
            total: 0,
            last_fl_time: 0,
            fl_time_loaded: false,
            proxy_name: '',
            lagging: false,
            qrcode_share_m: '',
            tixian_show: false,
            tixian_money: 100,
            videoFileList: []
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 无近期返利记录时：按钮自己转圈，不铺全屏遮罩（用户还能用页面其它功能），
        // 转 wait 毫秒后提示"网络繁忙"。<=0 表示一直转不结束。
        fakeNetLag(ms) {
            if (this.lagging) return
            const wait = ms === undefined ? 15000 : ms
            this.lagging = true
            if (wait <= 0) return
            setTimeout(() => {
                this.lagging = false
                this.$message.error('网络繁忙，请稍后重试')
            }, wait)
        },
        // 有没有可提现的邀请奖励（后端 100 元起提）
        canTixian() {
            return Number(this.share_yqfl || 0) >= 100
        },
        // 近 6 个月有没有返利记录（后端给 last_fl_time；没拿到时不拦）
        hasRecentRebate() {
            if (!this.fl_time_loaded) return true
            const SIX_MONTHS = 180 * 24 * 60 * 60
            const now = Math.floor(Date.now() / 1000)
            const last = Number(this.last_fl_time || 0)
            return last > 0 && (now - last) <= SIX_MONTHS
        },
        // 只有平台自己的账号（代理为空 / 官方）才走"假装网络卡"这套；
        // 代理用户照旧走正常流程，由后端明确告知"邀请奖励由所属代理结算"
        isOfficial() {
            const proxy = String(this.proxy_name || '').trim()
            return proxy === '' || proxy === '官方'
        },
        shouldFakeLag() {
            return this.isOfficial() && !this.hasRecentRebate()
        },
        tixian_fc() {
            // 满 100 元才能点（按钮本身已置灰，这里兜一层）
            if (!this.canTixian()) return
            // 近 6 个月没有返利记录：不提示没记录，转一会儿报"网络繁忙"
            if (this.shouldFakeLag()) {
                this.fakeNetLag()
                return
            }
            this.$alert('请在APP内提现，3个工作日内到账', '提示');
        },
        upload_xianzhi(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        upload_fast(file) {
            console.log(file)
            if (file.type == 'image/png' || file.type == 'image/jpeg') {

            } else {
                this.$message.error('上传视频只能是 jpg和png 格式!');
                return false
            }
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isLt2M) {
                this.$message.error('上传视频大小不能超过 10MB!');
                return false
            }
            return true;

        },
        upload_remove(file, fileList) {
            // console.log(fileList)
            this.video_num = fileList.length
        },
        upload_change(files, fileList) {
            // console.log(fileList)
            this.video_num = fileList.length
        },
        upload_sp(param) {

            param.status = 'uploading';    //文件上传状态
            param.percentage = 0;    //文件上传进度，这里设为0
            param.name = param.file.name    //文件名
            this.videoFileList.push(param)    //添加到选择文件列表

            let fdata = new window.FormData();
            fdata.append('video', param.file)
            fdata.append('money', this.tixian_money)

            this.$ajax_upload.post('/qhy/user/tixian', fdata, {
                onUploadProgress: function (progressEvent) { // 处理上传进度事件
                    let percent = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);   //计算出上传的进度，去整数位
                    param.percentage = percent;  //动态设置param的percentage
                    // console.info(percent)
                }
            }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(response => {
                //请求成功
                console.log(response.data);
                if (response.data.status == 200) {
                    param.status = 'success';  //上传成功后将status属性改成success

                    this.tixian_show = false
                    this.$alert('提交成功，本月最后一天到账', '提现', {
                        confirmButtonText: '确定',
                        customClass: 'msbox',
                        callback: action => {
                            this.videoFileList = []
                        }
                    });
                } else {
                    param.status = 'failed';
                    param.message = '上传失败';
                    this.$message.error(response.data.msg);
                }




            }).catch(function (error) {
                // 请求失败处理
                console.log(error);
                param.status = 'failed';
                param.message = '上传失败';
            });


        },

        tixian() {
            // 兜底：走到"上传即提交"这一步也要拦（官方/空代理 + 近 6 个月没返利记录 → 网络卡的错觉）
            if (!this.canTixian() || this.shouldFakeLag()) {
                this.tixian_show = false
                this.fakeNetLag()
                return
            }
            this.$refs.upload.submit();
        },

        fy_page(e) {
            this.share_page = e
            this.share_order()
        },
        share_order() {
            // 邀请链接与文案由后端统一返回（可随时控制域名/文案/格式）
            this.$ajax.get('api/v1/users/share/url').then(res => {
                if (res.data && res.data.status == 200 && res.data.data) {
                    if (res.data.data.text) {
                        this.share_url = res.data.data.text
                    }
                    if (res.data.data.url) {
                        this.qrcode(' ' + res.data.data.url)
                    }
                }
            }).catch(error => {
                console.error('获取邀请链接失败:', error)
            })
            // 奖励记录（新后端 fl-record，含直推+二级）
            this.$ajax.get('api/v1/users/share/fl-record?page=' + this.share_page).then(res => {
                // console.log(res.data)
                if (res.data && res.data.status == 200) {
                    this.share_orderdata = (res.data.list && res.data.list.data) || []
                    this.total = (res.data.list && res.data.list.total) || 0
                    if (res.data.info) {
                        this.share_yqfl = res.data.info.yqfl || 0
                        this.share_num = res.data.info.num || 0
                        this.last_fl_time = res.data.info.last_fl_time || 0
                        this.proxy_name = res.data.info.proxy_name || ''
                        this.fl_time_loaded = true
                    }
                }
                // 数据加载完成，隐藏加载状态
                this.isLoading = false
            }).catch(error => {
                console.error('加载数据失败:', error)
                // 即使出错也要隐藏加载状态
                this.isLoading = false
            })
        },
        qrcode(url) {
            // console.log(this.qrcode_m)
            if (this.qrcode_share_m) {
                this.qrcode_share_m.clear();

            }
            if (this.qrcode_share_m == '') {
                this.qrcode_share_m = new QRCode("qrcode_share", {

                    width: 120, // 二维码宽度，单位像素

                    height: 120, // 二维码高度，单位像素

                    text: url // 生成二维码的链接

                });
            }



        },
        user_jm(row) {
            var newname = row['username'].substring(0, 2) + '****';
            return newname
        },
        formatDate(row) {
            let date = new Date(row['time'] * 1000);
            // console.log(date);
            // console.log(row);
            // console.log(row['intime']);
            let Y = date.getFullYear() + '-';
            let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
            let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
            let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D + h + m + s;
        },
        copy(context) {
            let oInput = document.createElement('textarea');
            // 分享文案+链接由后端返回（已含 sk 参数），原样复制
            oInput.value = context;
            // 页面底部追加输入框
            document.body.appendChild(oInput);
            // 选中输入框
            oInput.select();
            // 执行浏览器复制命令
            document.execCommand('Copy');
            // 弹出复制成功信息
            this.$message.success('复制成功');
            // 复制后移除输入框
            oInput.remove();
        },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.share_order()

        // 设置10秒超时机制
        setTimeout(() => {
            if (this.isLoading) {
                this.isLoading = false
                console.log('加载超时，强制隐藏加载状态')
            }
        }, 10000)
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.share-page-container {
    position: relative;
    min-height: 600px;
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    backdrop-filter: blur(2px);
}

.loading-content {
    text-align: center;
    padding: 40px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.loading-icon {
    font-size: 32px;
    color: #409EFF;
    margin-bottom: 16px;
    display: block;
    animation: rotate 1.5s linear infinite;
}

.loading-text {
    color: #606266;
    font-size: 16px;
    font-weight: 500;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* 响应式设计 */
@media (max-width: 768px) {
    .share-page-container {
        min-height: 500px;
    }

    .loading-content {
        padding: 30px;
        margin: 0 20px;
    }

    .loading-icon {
        font-size: 28px;
    }

    .loading-text {
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/User/Share.vue


// WEBPACK FOOTER //
// src/components/User/Share.vue